// Lib
import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose, onlyUpdateForPropTypes } from '../../../../../node_module_clones/recompose';

// Components
import ElementSearchResultBoard from './ElementSearchResultBoard';
import ElementSearchResultQuickNotes from './ElementSearchResultQuickNotes';

// Selector
import boardSearchResultSelector from './boardSearchResultSelector';

// Utils
import { getElementId } from '../../../../../common/elements/utils/elementPropertyUtils';

// Constants
import { SEARCH_RESULT_TYPE } from './elementSearchConstants';

const SearchResult = ({
    board,
    searchedCurrentBoardId,
    currentBoardId,
    resultsCount,
    linkUrl,
    searchQuery,
    gridSize,
    setFocusIndex,
    focusOnInput,
    index,
    hasNavigated,
    result,
    ...rest
}) => {
    const isCurrentBoardResult =
        board &&
        !hasNavigated &&
        getElementId(board) === searchedCurrentBoardId &&
        result.resultType === SEARCH_RESULT_TYPE.CURRENT_BOARD;

    if (result.resultType === SEARCH_RESULT_TYPE.QUICK_NOTES) {
        return (
            <ElementSearchResultQuickNotes
                {...rest}
                board={board}
                searchQuery={searchQuery}
                result={result}
                resultsCount={resultsCount}
                setFocusIndex={setFocusIndex}
                focusOnInput={focusOnInput}
                index={index}
                linkUrl={linkUrl}
            />
        );
    }

    return (
        <ElementSearchResultBoard
            isCurrentBoardResult={isCurrentBoardResult}
            currentBoardId={currentBoardId}
            board={board}
            searchQuery={searchQuery}
            gridSize={gridSize}
            resultsCount={resultsCount}
            setFocusIndex={setFocusIndex}
            focusOnInput={focusOnInput}
            index={index}
            linkUrl={linkUrl}
        />
    );
};

SearchResult.propTypes = {
    board: PropTypes.object,
    result: PropTypes.object,

    searchQuery: PropTypes.string,
    linkUrl: PropTypes.string,
    resultsCount: PropTypes.number,
    gridSize: PropTypes.number,
    searchedCurrentBoardId: PropTypes.string.isRequired,
    currentBoardId: PropTypes.string.isRequired,

    setFocusIndex: PropTypes.func,
    focusOnInput: PropTypes.func,
    index: PropTypes.number,

    hasNavigated: PropTypes.bool,
};

const enhancer = compose(connect(boardSearchResultSelector), onlyUpdateForPropTypes);

export default enhancer(SearchResult);
